<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" epub:type="pagebreak" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm"><a class="xref" href="#/umaWILSONCalifornia0007#pref">Preface</a></p>
<p class="tocfm"><a class="xref" href="#/umaWILSONCalifornia0008#acknow">Acknowledgments</a></p>
<p class="tocf"><a class="xref" href="#/umaWILSONCalifornia0010#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/umaWILSONCalifornia0011#ch01">1. From East to Far West</a></p>
<p class="toc"><a class="xref" href="#/umaWILSONCalifornia0012#ch02">2. Salt Lake City</a></p>
<p class="toc"><a class="xref" href="#/umaWILSONCalifornia0013#ch03">3. Emerson in California</a></p>
<p class="toc"><a class="xref" href="#/umaWILSONCalifornia0014#ch04">4. Touring San Francisco and the Bay Area</a></p>
<p class="toc"><a class="xref" href="#/umaWILSONCalifornia0015#ch05">5. Yosemite</a></p>
<p class="toc"><a class="xref" href="#/umaWILSONCalifornia0016#ch06">6. The Mariposa Big Trees</a></p>
<p class="toc"><a class="xref" href="#/umaWILSONCalifornia0017#ch07">7. Last Days in California</a></p>
<p class="toc"><a class="xref" href="#/umaWILSONCalifornia0018#ch08">8. Emerson after California</a></p>
<p class="tocbmf"><a class="xref" href="#/umaWILSONCalifornia0019#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/umaWILSONCalifornia0021#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-WILSON-California-0006.vue?76ecad58